export default {
  'YEARLY_PAYMENT_RECURRING_TRIAL': {
    'nextBillDate': '',
    'chargePrice': '0.00',
    'regularPrice': '59.88'
  },
  'TB4T_YEARLY_PAYMENT': {
    'chargePrice': '69.00',
    'regularPrice': '69.00'
  },
  'TB4T_YEARLY_PAYMENT_TRIAL': {
    'nextBillDate': '',
    'chargePrice': '0.00',
    'regularPrice': '69.00'
  },
  'MONTHLY_PAYMENT': {
    'chargePrice': '9.99',
    'regularPrice': '9.99'
  },
  'TWO_YEAR_PAYMENT': {
    'chargePrice': '99.99',
    'regularPrice': '99.99'
  },
  'YEARLY_PAYMENT_RECURRING': {
    // 'salePrice': '49.88',
    'chargePrice': '59.88', // during a sale, this must be the same as the sale price
    'regularPrice': '59.88'
  }
}



// WEBPACK FOOTER //
// ./src/data/pricing.js